/* ==========================================================================
   Go Damn — premium layer behaviour
   - quick add to cart     [data-gdh-atc]
   - product rails         [data-gdh-rail-root]
   - shade finder          [data-gdh-sf]
   - count-up stats        [data-gdh-count]
   - reveal on scroll      .gdh-rv
   Loaded (deferred) from layout/theme.liquid BEFORE gd-motion.js, so it can
   tell gd-motion to leave these sections alone (they reveal themselves).
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- */
  /* gd-motion hand-off                                                */
  /* ---------------------------------------------------------------- */
  function skipMotion(scope) {
    each((scope || document).querySelectorAll('.gdh-sec, .gdh-marquee'), function (el) {
      var s = el.closest('.shopify-section');
      if (s) s.setAttribute('data-gd-skip', '');
    });
  }

  /* ---------------------------------------------------------------- */
  /* Reveal                                                            */
  /* ---------------------------------------------------------------- */
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  }

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.gdh-rv:not([data-gdh-rv])');
    if (!els.length) return;
    var h = window.innerHeight || document.documentElement.clientHeight;
    var tops = [];
    each(els, function (el, i) { tops[i] = el.getBoundingClientRect().top; });
    each(els, function (el, i) {
      el.setAttribute('data-gdh-rv', '');
      if (!io || tops[i] < h * 0.92) return; /* already on screen: leave it visible */
      el.classList.add('gdh-rv--armed');
      io.observe(el);
    });
    /* safety net for background tabs / late layout */
    setTimeout(function () {
      each(document.querySelectorAll('.gdh-rv--armed:not(.is-in)'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------------------------------------------------------------- */
  /* Quick add to cart                                                 */
  /* ---------------------------------------------------------------- */
  function setLabel(btn, text) {
    var l = btn.querySelector('[data-gdh-label]');
    if (l) l.textContent = text; else btn.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gdh-atc]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();

    var label = btn.querySelector('[data-gdh-label]');
    var original = label ? label.textContent : btn.textContent;
    btn.setAttribute('aria-busy', 'true');

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-gdh-atc'), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || 'Could not add to cart');
          return j;
        });
      })
      .then(function () { return fetch(rootUrl + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        btn.setAttribute('data-state', 'added');
        setLabel(btn, 'Added');
        each(document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count'), function (el) { el.textContent = cart.item_count; });
        /* Horizon listens for cart:update and re-renders the cart icon + drawer */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'gdh', data: { itemCount: cart.item_count, source: 'gd-home' } }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (btn.hasAttribute('data-gdh-open-cart')) {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            setTimeout(function () { drawer.open(); }, 250);
          }
        }
        setTimeout(function () { btn.removeAttribute('data-state'); setLabel(btn, original); }, 2000);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        setLabel(btn, /sold out|not available|inventory/i.test(err && err.message) ? 'Sold out' : 'Try again');
        setTimeout(function () { setLabel(btn, original); }, 2200);
      });
  });

  /* ---------------------------------------------------------------- */
  /* Rails: arrows + progress bar                                      */
  /* ---------------------------------------------------------------- */
  function initRail(root) {
    if (root.dataset.gdhBound) return;
    root.dataset.gdhBound = '1';
    var rail = root.querySelector('[data-gdh-rail]');
    var ui = root.querySelector('[data-gdh-rail-ui]');
    var bar = root.querySelector('[data-gdh-progress]');
    var thumb = bar && bar.querySelector('i');
    var prev = root.querySelector('[data-gdh-prev]');
    var next = root.querySelector('[data-gdh-next]');
    if (!rail) return;

    var ticking = false;
    function update() {
      ticking = false;
      var sw = rail.scrollWidth, cw = rail.clientWidth, sl = rail.scrollLeft;
      var max = sw - cw;
      if (ui) ui.hidden = max <= 4;
      if (thumb && bar) {
        var bw = bar.clientWidth;
        var tw = Math.max(bw * (cw / sw), 40);
        thumb.style.width = tw + 'px';
        thumb.style.transform = 'translateX(' + (max > 0 ? (bw - tw) * (sl / max) : 0) + 'px)';
      }
      if (prev) prev.disabled = sl <= 4;
      if (next) next.disabled = sl >= max - 4;
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    function step(dir) {
      var card = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var w = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      var per = Math.max(1, Math.floor((rail.clientWidth + gap) / w));
      rail.scrollBy({ left: dir * w * per, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(rail);
    update();
  }

  /* ---------------------------------------------------------------- */
  /* Shade finder                                                      */
  /* ---------------------------------------------------------------- */
  function initShadeFinder(root) {
    if (root.dataset.gdhBound) return;
    root.dataset.gdhBound = '1';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gdh-chip]'));
    var panels = root.querySelectorAll('[data-gdh-panel]');
    var imgs = root.querySelectorAll('[data-gdh-img]');
    var tag = root.querySelector('[data-gdh-tag]');
    var tagDot = root.querySelector('[data-gdh-tag-dot]');

    function show(i, focus) {
      chips.forEach(function (c, n) {
        var on = n === i;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        if (on && focus) c.focus();
      });
      each(panels, function (p, n) { p.hidden = n !== i; });
      each(imgs, function (im, n) {
        im.classList.toggle('is-active', n === i);
        if (n === i) {
          var lazy = im.querySelector('img[loading="lazy"]');
          if (lazy) lazy.loading = 'eager';
        }
      });
      if (tag && chips[i]) tag.textContent = chips[i].getAttribute('data-name') || '';
      if (tagDot && chips[i]) {
        var dot = chips[i].querySelector('.gdh-chip__dot');
        if (dot) tagDot.setAttribute('style', dot.getAttribute('style') || '');
      }
    }

    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { show(i, false); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % chips.length;
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + chips.length) % chips.length;
        if (k === 'Home') n = 0;
        if (k === 'End') n = chips.length - 1;
        if (n !== null) { e.preventDefault(); show(n, true); }
      });
    });
    /* warm the next images once the section is close to the screen */
    if ('IntersectionObserver' in window) {
      var warm = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        each(root.querySelectorAll('[data-gdh-img] img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
        warm.disconnect();
      }, { rootMargin: '300px 0px' });
      warm.observe(root);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Count-up numbers                                                  */
  /* ---------------------------------------------------------------- */
  function initCounts(scope) {
    var els = (scope || document).querySelectorAll('[data-gdh-count]:not([data-gdh-counted])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-gdh-counted', '');
      var target = parseFloat(el.getAttribute('data-gdh-count')) || 0;
      var decimals = (String(target).split('.')[1] || '').length;
      var num = el.querySelector('[data-gdh-num]') || el;
      if (reduce) { num.textContent = target.toFixed(decimals); return; }
      var start = null, dur = 1400;
      function frame(t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        num.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(frame);
      }
      num.textContent = (0).toFixed(decimals);
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in window)) { each(els, run); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        run(en.target);
      });
    }, { threshold: 0.4 });
    each(els, function (el) {
      /* numbers already on screen at load just show their value */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { el.setAttribute('data-gdh-counted', ''); return; }
      var num = el.querySelector('[data-gdh-num]') || el;
      num.textContent = '0';
      cio.observe(el);
    });
  }

  /* ---------------------------------------------------------------- */
  /* Boot                                                              */
  /* ---------------------------------------------------------------- */
  function init(scope) {
    var s = scope || document;
    skipMotion(s);
    each(s.querySelectorAll('[data-gdh-rail-root]'), initRail);
    each(s.querySelectorAll('[data-gdh-sf]'), initShadeFinder);
    initCounts(s);
    reveal(s);
  }

  try { init(); } catch (err) { if (window.console) console.warn('[gd-home]', err); }

  document.addEventListener('shopify:section:load', function (e) {
    try { init(e.target); } catch (err) {}
  });
})();
